import React from 'react';
import { connect } from 'react-redux';
import { FormGroup, Label, Input } from 'reactstrap';
import { selectLanguge } from './actions';
import { getSelectedLanguage } from './selectors';

const LanguageSelect = ({ selectLanguge, lang }) => {
  return (
    <FormGroup>
      <Label for="langSelect">Mutace</Label>
      <Input
        type="select"
        name="langSelect"
        id="langSelect"
        value={lang}
        onChange={e => selectLanguge(e.target.value)}
      >
        <option value="">Vyberte mutaci</option>
        <option value="cs">CS</option>
        <option value="en">EN</option>
      </Input>
    </FormGroup>
  );
};

export default connect(
  state => ({
    lang: getSelectedLanguage(state)
  }),
  { selectLanguge }
)(LanguageSelect);



// WEBPACK FOOTER //
// ./src/modules/HomepageSettings/LanguageSelect.js